import "../interface/appUserId.mjs";
import "@kakaopay-common/payweb-core";
import "../constants.mjs";
import { Device, Browser } from "@kakaopay-common/user-agent";
import "../interface/openFaq.mjs";
import "../interface/openCS.mjs";
import "../interface/openNotice.mjs";
import "../interface/openPrivateAsk.mjs";
import "lodash.merge";
import { closeWebview } from "../interface/ViewControl/closeWebview.mjs";
import "../interface/ViewControl/scrollBounces.mjs";
const backIconImage = (color = "#060B11") => `<g fill="none" fill-rule="evenodd">
    <g fill="${color}">
        <g>
            <g>
                <g>
                    <g>
                        <path d="M2.062 12.26l-.019-.06-.004-.014-.001-.008-.003-.012c-.007-.032-.012-.064-.015-.097l-.002-.013-.001-.037v-.047l.005-.062v-.003l.001-.009c.005-.038.014-.076.025-.113l.014-.042.004-.01.026-.063.01-.02.008-.014.02-.032.018-.029.015-.02.03-.038.022-.025.01-.012.03-.029 7.758-7.525c.298-.288.773-.281 1.06.016.263.27.28.688.059.978l-.074.083-6.444 6.246 16.886.001c.414 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007H4.616l6.442 6.247c.297.289.304.763.016 1.06-.262.271-.679.302-.975.088l-.086-.071-7.769-7.536-.016-.016c-.034-.035-.065-.073-.09-.113l-.012-.019c-.01-.015-.018-.03-.027-.047l-.013-.027-.005-.01-.006-.014-.013-.033z" transform="translate(-767 -2849) translate(753 2795) translate(0 44) translate(4) translate(10 10)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</g>`;
const closeIconImage = (color = "#060B11") => `<g fill="none" fill-rule="evenodd">
    <g fill="${color}">
        <g>
            <g>
                <g>
                    <g>
                        <path d="M20 4c.268.268.29.69.067.984L20 5.06l-6.94 6.938L20 18.94c.293.293.293.768 0 1.061-.268.268-.69.29-.984.067L18.94 20 12 13.06 5.061 20c-.293.293-.768.293-1.061 0-.268-.268-.29-.69-.067-.984L4 18.94 10.94 12 4 5.061C3.707 4.768 3.707 4.293 4 4c.268-.268.69-.29.984-.067L5.06 4l6.938 6.94L18.94 4c.293-.293.768-.293 1.061 0z" transform="translate(-580 -3069) translate(243 3015) translate(229 44) translate(98) translate(10 10)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</g>`;
var TITLE_TEXT_ALIGN_TYPE = /* @__PURE__ */ ((TITLE_TEXT_ALIGN_TYPE2) => {
  TITLE_TEXT_ALIGN_TYPE2["LEFT"] = "left";
  TITLE_TEXT_ALIGN_TYPE2["RIGHT"] = "right";
  TITLE_TEXT_ALIGN_TYPE2["NONE"] = "none";
  return TITLE_TEXT_ALIGN_TYPE2;
})(TITLE_TEXT_ALIGN_TYPE || {});
const closeEvent = () => {
  closeWebview();
};
const defaultBackEvent = () => {
  const pathName = window.location.pathname;
  window.history.back();
  setTimeout(() => {
    if (window.location.pathname === pathName) {
      closeWebview();
    }
  }, 300);
};
const defaultLeftEvent = defaultBackEvent;
const defaultRightEvent = closeEvent;
const defaultTextAlign = "none";
const defaultOptions = {
  disableDarkmode: false,
  back: {
    callback: defaultBackEvent
  },
  backgroundColor: {
    light: "#ffffff",
    dark: "#2a2a2a"
  },
  height: Device.isIos() ? 44 : 56,
  left: {
    callback: defaultLeftEvent,
    color: {
      light: "#060B11",
      dark: "#ffffff"
    },
    icon: backIconImage,
    visible: true
  },
  right: {
    callback: defaultRightEvent,
    color: {
      light: "#060B11",
      dark: "#ffffff"
    },
    icon: closeIconImage,
    visible: true
  },
  title: {
    bold: false,
    color: {
      light: "#060B11",
      dark: "#ffffff"
    },
    size: 17,
    text: "",
    align: defaultTextAlign
  },
  visible: !Browser.isFragmentWebview(),
  zIndex: 2147483647,
  bottomBorder: {
    visible: false,
    width: 0.5,
    color: "#d7d7de"
  }
};
function getDefaultOptions() {
  return defaultOptions;
}
export {
  TITLE_TEXT_ALIGN_TYPE,
  defaultOptions,
  getDefaultOptions
};
